export let aboutApp = "qgHtcd";
export default {aboutApp};